


























































































import { Component, Prop, Vue } from "vue-property-decorator";
import userSettings from "../components/userSettings.vue";
import teamInfo from "../components/teamInfo.vue";
import teamChange from "../components/teamChange.vue";
import consts from "../consts";
import { MemberToAdd, User, UserStat } from "../types";
import axios from "axios";
import moment from "moment";
import { Getter } from "vuex-class";

@Component({
  components: {
    userSettings,
    teamInfo,
    teamChange
  },
  filters: {
    moment(date: string) {
      return moment(date).format("YYYY - MM - DD");
    }
  }
})
export default class AddTeam extends Vue {
  @Prop() private JWT!: string;
  @Getter private currentTeamID!: string;
  @Prop() private currentTeam!: any;
  @Prop() private currentTeamUsers!: User[];
  @Prop() private currUser!: User;
  @Prop() private teamID!: string;
  @Prop() private userStats!: UserStat[];
  @Prop() private refreshTeamsData!: Function;
  @Prop() private changeTeam!: (teamID: any) => any
  
  private error: boolean = false;
  private errorMsg: string = "An Error Has Occured";
  private loading: boolean = false;
  private isEditing: boolean = false;
  private rubric: any = {
    name: "",
    questions: [
      {
        question: "",
        displayOrder: 1,
        answers: [
          {
            displayOrder: 1,
            answer: ""
          }
        ]
      }
    ]
  };

  private created() {
    if (this.$route.name === "editRubric") {
      this.isEditing = true;
      this.loading = true;
      this.fetchRubric();
    }
  }

  private fetchRubric() {
    let rubricID = this.$route.params.rubricID;
    axios({
      method: "GET",
      url: consts.serverURL + "rubric/" + rubricID,
      headers: { Authentication: this.JWT }
    })
      .then(resp => {
        console.log("FETCH RUBRIC", resp.data);
        this.loading = false;
        this.rubric = resp.data;
      })
      .catch(reason => {
        console.log(reason, reason.response);
      });
  }

  private updateRubric() {
    if (this.rubric.rubricSlug) {
      this.loading = true;
      let data = {
        name: this.rubric.name,
        version: this.rubric.version,
        questions: this.rubric.questions
      };
      axios({
        method: "PUT",
        url: consts.serverURL + "rubric/" + this.rubric.rubricSlug,
        headers: { Authentication: this.JWT },
        data
      })
        .then(resp => {
          console.log("UPDATE RUBRIC", resp.data);
          this.loading = false;
        })
        .catch(reason => {
          console.log(reason, reason.response);
          this.error = true;
          this.errorMsg = reason.response.data.Error;
          this.loading = false;
        });
    }
  }

  private addRubric() {
    this.loading = true;
    axios({
      method: "POST",
      url: consts.serverURL + "rubric/" + this.teamID,
      headers: { Authentication: this.JWT },
      data: this.rubric
    })
      .then(resp => {
        console.log("ADD RUBRIC", resp.data);
        this.loading = false;
        this.$router.push({ name: "team", params: { teamID: this.teamID } });
      })
      .catch(reason => {
        console.log(reason, reason.response);
        this.error = true;
        this.errorMsg = reason.response.data.Error;
        this.loading = false;
      });
  }

  private deleteRubric() {
    if (this.rubric.rubricSlug && this.rubric.version) {
      this.loading = true;
      axios({
        method: "DELETE",
        url:
          consts.serverURL +
          "rubric/" +
          this.rubric.rubricSlug +
          "/" +
          this.rubric.version,
        headers: { Authentication: this.JWT }
      })
        .then(resp => {
          console.log("DELETE RUBRIC");
          this.loading = false;
          this.$router.push({ name: "team", params: { teamID: this.teamID } });
        })
        .catch(reason => {
          console.log(reason, reason.response);
          this.error = true;
          this.errorMsg = reason.response.data.Error;
          this.loading = false;
        });
    }
  }

  private addQuestion() {
    let max = 0;
    for (let i = 0; i < this.rubric.questions.length; ++i) {
      max = Math.max(max, this.rubric.questions[i].displayOrder);
    }
    this.rubric.questions.push({
      question: "",
      displayOrder: max + 1,
      answers: [
        {
          displayOrder: 1,
          answer: ""
        }
      ]
    });
  }

  private deleteQuestion(i: number) {
    if (this.rubric.questions.length > 1) {
      this.rubric.questions.splice(i, 1);
    }
  }

  private addAnswer(question: any) {
    let max = 0;
    for (let i = 0; i < question.answers.length; ++i) {
      max = Math.max(max, question.answers[i].displayOrder);
    }
    question.answers.push({
      displayOrder: max + 1,
      answer: ""
    });
  }

  private deleteAnswer(question: any, i: number) {
    if (question.answers.length > 1) {
      question.answers.splice(i, 1);
    }
  }
}
